import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';

import "./Textarea.scss";

const Textarea = (props) => {

    const {
      className,
      others,
      onChange,
      name,
      value,
      label,
      type,
      error,
      placeholder,
    } = props;

    const style = classes('textarea', className);

    return (
      <div className={style}>
        {error && <span className="error-block">{error}</span>}

        <span className="input-block__label">{label}</span>
        <textarea
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...others}
        />
      </div>
    )
};

Textarea.propTypes = {
  others: PropTypes.object,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  error: PropTypes.string,
};

Textarea.defaultProps = {
  type: 'text',
  value: ''
};

export default Textarea;



// WEBPACK FOOTER //
// ./src/app/components/Textarea/index.js